module.exports = __webpack_public_path__ + "img/close.41bf6e2b.png";